import { render, staticRenderFns } from "./Tour360.vue?vue&type=template&id=64fba488&scoped=true&"
import script from "./Tour360.vue?vue&type=script&lang=js&"
export * from "./Tour360.vue?vue&type=script&lang=js&"
import style0 from "./Tour360.vue?vue&type=style&index=0&id=64fba488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fba488",
  null
  
)

export default component.exports